import AccordionToggle from './DataAccordion'

export default AccordionToggle
